<template>
    <div class="flex border-t -mb-px border-gray-200 bg-white">
        <div class="flex-1 p-0 -ml-px flex" :class="readOnly?'truncate':''">
            <page-cell
                :read-only="readOnly"
                class="text-gray-500 -mt-px px-2 mb-0 py-1 border-l border-gray-200 hover:z-30 focus:z-40 whitespace-pre"
                :class="readOnly?'truncate':''"
                placeholder="Material..."
                v-model="name"
                @change="$emit('change',item,{name:name,uom:uom})"
            ></page-cell>
        </div>
        <div class="w-28 p-0 -ml-px flex">
            <page-cell
                :read-only="readOnly"
                class="text-gray-500 -mt-px px-2 mb-0 py-1 border-l border-gray-200 hover:z-30 focus:z-40 whitespace-pre"
                :class="readOnly?'truncate':''"
                placeholder="UoM..."
                v-model="uom"
                @change="$emit('change',item,{name:name,uom:uom})"
            ></page-cell>
        </div>
        <div class="w-28 p-0 -ml-px"  @mouseleave="closeDropDown">
            <ui-dropdown placement="bottom-start" menu-class="p-3 w-96 z-50" class="flex w-full" ref="dropdown"
                         trigger-class="flex w-full">
                <template #default="{ open, close }">
                    <div class="w-full -my-px -ml-px p-0 text-sm"
                         @mouseenter="calculateAndOpen(open)">
            <page-cell
                :read-only="true"
                class="text-gray-500 flex -mt-px px-2 mb-0 py-1 border-l border-r border-gray-200 hover:z-30 focus:z-40 whitespace-pre text-right truncate"
                v-model="qty"
            ></page-cell>
                    </div></template>
                <template #menu>
                    <div class="">
                        <div class="text-gray-600 text-sm font-semibold w-full mb-1">
                            Material usage across Cost Plan:
                        </div>
                        <div class="max-h-96 pr-2 pt-1 overflow-y-auto">
                            <div class="text-gray-400 text-xs w-full pl-0 pt-0" v-for="section in usage">
                                <div class="flex">
                                    <div class="flex-grow truncate">Section : <span
                                        class="text-gray-600 text-sm"
                                        v-text="section.name"></span>
                                    </div>
                                </div>
                                <div class="w-full text-gray-400 text-xs pl-1.5" v-for="task in section.tasks">
                                    <div class="flex">
                                        <div class="flex-grow truncate">Task : <span
                                            class="text-gray-600 text-sm"
                                            v-text="task.name"></span>
                                        </div>
                                    </div>
                                    <div class="w-full text-gray-400 text-xs pl-1.5" v-for="item in task.items">
                                        <div class="flex">
                                            <div class="flex-grow truncate"> Item : <span
                                                class="text-gray-600 text-sm"
                                                v-text="item.name"></span>
                                            </div>
                                            <div class="text-blue-600 text-sm"
                                                 v-text="math.round(item.count,2)"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import * as math from "mathjs";
import PageCell from "../../../ui/PageCell.vue";
export default {
    components: {PageCell},
    props: {
        costPlan:Object,
        item: Object,
        readOnly: false,
    },
    data() {
        return {
            math,
            name:''+(this.item.name?this.item.name:''),
            uom:''+(this.item.uom?this.item.uom:''),
            qty:math.round(this.item.quantity,3),
            usage:false,
        }
    },
    computed: {},
    methods: {
        closeDropDown() {
            this.$refs.dropdown.close()
        },
        calculateAndOpen(open) {
            if (!this.usage) {
                let usage = []
                let buildUsage = (section, sIndex, task, tIndex, item, iIndex, material) => {
                    let s = usage.find((u) => (u.index === sIndex))
                    if (!s) {
                        s = {index: sIndex, name: section.title, tasks: []}
                        usage.push(s)
                    }
                    let t = s.tasks.find((u) => (u.index === tIndex))
                    if (!t) {
                        t = {index: tIndex, name: task.reference + ' • ' + task.name, items: []}
                        s.tasks.push(t)
                    }
                    let i = t.items.find((u) => (u.index === iIndex))
                    if (!i) {
                        i = {index: iIndex, name: item.reference + ' • ' + item.description, count: 0}
                        t.items.push(i)
                    }
                    i.count += parseFloat(material.quantity);
                }
                for (let sIndex = 0; sIndex < this.costPlan.sections.length; sIndex++) {
                    let section = this.costPlan.sections[sIndex];
                    if ((!section.omitted)) {
                        for (let tIndex = 0; tIndex < section.tasks.length; tIndex++) {
                            let task = section.tasks[tIndex];
                            if ((!task.omitted)) {
                                for (let iIndex = 0; iIndex < task.items.length; iIndex++) {
                                    let item = task.items[iIndex];
                                    if ((!item.omitted)) {
                                        if (item.buildup) {
                                            for (let m = 0; m < item.buildup.materials.length; m++) {
                                                let material = item.buildup.materials[m]
                                                if ((material.name === this.item.name) && (material.uom === this.item.uom)) {
                                                    buildUsage(section, sIndex, task, tIndex, item, iIndex, material)
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.usage = usage
                this.$nextTick(() => {
                    open();
                })
            } else {
                open()
            }
        },
    },
    mounted() {
    }
}
</script>
